export const setMeta = (seo) => {
  document.title = seo.title || 'Les-filles-et-les-sciences'
  const metas = document.getElementsByTagName('meta')
  metas['og:title'].content = seo.title || 'Les Filles et les Sciences'
  metas['description'].content =
    seo.description ||
    '« Les filles et les sciences, un duo électrisant! » vise à te faire connaître la nature exacte des professions scientifiques et technologiques et des études qui y mènent.'
  metas['og:description'].content =
    seo.description ||
    '« Les filles et les sciences, un duo électrisant! » vise à te faire connaître la nature exacte des professions scientifiques et technologiques et des études qui y mènent.'
  metas['og:image'].content = seo.image?.original || seo.image || ''
  metas['og:type'].content = seo.type || 'website'
  metas['twitter:card'].content = seo.twitter || 'summary'
}
